export default function TrustStrip() {
  const items = [
    "Fiduciary Advice",
    "Independent",
    "Customized",
    "Transparent Costs",
  ];
  return (
    <section className="bg-slate-50 border-t border-slate-200">
      <div className="mx-auto flex max-w-6xl items-center justify-center px-4 py-5 md:px-6">
        <ul className="value-props flex flex-wrap items-center gap-x-6 gap-y-3 md:gap-x-8">
          {items.map((label, i) => (
            <li key={label} className="value-prop-item flex items-center">
              {i !== 0 && (
                <span
                  aria-hidden="true"
                  className="value-prop-line mx-4 inline-block h-px w-10 bg-slate-300 align-middle md:mx-6 md:w-14"
                />
              )}
              <span className="value-prop-label uppercase tracking-[0.14em] text-[12px] text-slate-600">
                {label}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
